<template>
  <div v-if="tooltip_data.show_tooltip" class="countInfoOverlay"
       :class="{ 'is-static': !!tooltip_data.text }" :style="tooltipPos">

    <!-- Static (download button) tooltip mode -->
    <template v-if="tooltip_data.text">
      <div>{{ tooltip_data.text }}</div>
    </template>

    <!-- Month tooltip mode -->
    <template v-else>
      <h2>{{monthNames[tooltip_data.month]}} {{tooltip_data.year}} CPS</h2>
      <template v-if="hasLinkingCounts">
        <h3>Linking Specifications</h3>
        <ul>
          <li>
            Type: <b>{{ viewing_options.find((o) => o.id === selected_viewing_option).label }}</b>
          </li>
          <li>Count:
            <ul>
              <li v-for="(count, sample) in tooltip_data.linkingCounts" :key="sample">
                <b>{{ count }}</b> respondents from the <b>{{ sample }} ATUS</b>
              </li>
            </ul>
          </li>
        </ul>
      </template>

      <div class="monthSupplementTopics" v-if="tooltip_data.selectedSampleTopics?.length > 0">
        <h3>CPS Supplement Topics</h3>
        <ul>
          <li v-for="topic in tooltip_data.selectedSampleTopics">
            {{topic}}
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script setup>
import { makeTooltipData, monthNames } from "../lib/helpers";
import { computed, inject } from "vue";
import { useEventListener } from "@vueuse/core";

const tooltip_data = inject("tooltip_data");
const viewing_options = inject('viewing_options');
const selected_viewing_option = inject('selected_viewing_option');

const tooltipPos = computed(() => {
  return {
    bottom: `${tooltip_data.value.bottom}px`,
    left: `${tooltip_data.value.left}px`
  };
});

const hasLinkingCounts = computed(() => {
  return (
      tooltip_data.value?.linkingCounts &&
      Object.keys(tooltip_data.value.linkingCounts).length > 0
  );
});

useEventListener(window, "resize", () => {
  // Close tooltip on resize to prevent misalignment
  tooltip_data.value = makeTooltipData({show_tooltip: false});
});

</script>

<style scoped lang="scss">
.countInfoOverlay {
  position: absolute;
  pointer-events: none;
  z-index: 19;
  min-height: 105px;
  width: 290px;
  border: 1px solid #acacac;
  border-radius: 6px;
  padding: 5px 10px 5px 10px;
  background: #ffffe5;
  font-size: .8rem;
  li {
    margin-left: 1rem;
    list-style: disc outside none;

    li {
      list-style: circle;
    }
  }

  h2 {
    font-weight: 800;
    font-size: 0.9rem;
    margin-bottom: 5px;
  }
  h3 {
    font-weight: 500;
    font-size: .8rem;
    font-style: italic;
  }

  .monthSupplementTopics {
    margin-top: .5rem;
  }
  
  &.is-static {
    min-height: auto;   
  }
}

</style>